<template>
  <div id="app" class="common-container">
    <div class="wrapper subscription-constructor_page">
      <header-transparent />

      <main class="main">
        <router-view />
      </main>
    </div>

    <footer-base />
  </div>
</template>

<script>
import HeaderTransparent from "@/components/common/HeaderTransparent.vue";
import FooterBase from "@/components/common/FooterBase.vue";

export default {
  name: 'App',
  components: {
    HeaderTransparent,
    FooterBase
  }
}
</script>


<style lang="scss">
/* ------------ variables ------------ */
$main-font: 'PT Sans', sans-serif;
$main-font-size: 16px;
$main-text-color: #606670;

$titles-color: #242930;

/* form variables */
$input_font-family: $main-font;
$input_font-size: $main-font-size;
$input_color: $main-text-color;
$input_placeholder-color: #b5b8be;
$label_color: $titles-color;

/* transition */
$base-transition: all .3s cubic-bezier(.2,.57,.36,.8);


* {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
  font-family: $main-font;
  font-size: $main-font-size;
  color: $main-text-color;
  -webkit-font-smoothing: antialiased;
}

a {
  transition: $base-transition;
  color: $main-text-color;
  text-decoration: none;
  &:hover,
  &:focus {
    color: $main-text-color;
    text-decoration: none;
    outline: none;
  }
}

main.main {
  position: relative;
  z-index: 1;
}

/* ---------- grid system ---------- */
/* footer always at the bottom */
html, body,
.common-container {
  height: 100%;
  margin: 0;
  padding: 0;
}
body,
.common-container {
  display: flex;
  flex-direction: column;
}
.wrapper {
  flex: 1 0 auto;
}

.container {
  display: flex;
  margin: 0 auto;
  &.default {
    max-width: calc(1120px + 40px);
    padding: 0 20px;
  }
  @media only screen and (max-width: 640px) {
    &.default {
      padding: 0 16px;
    }
  }
}

/* ------------ helper ------------- */
ul, ol {
  display: flex;
  margin: 0;
  padding: 0;
  list-style: none;
}

/* --- form elements --- */
/* form-group */
.form-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0 0 16px 0;
  &:last-of-type {
    margin-bottom: 0;
  }
  .alert {
    position: relative;
    width: 100%;
    display: flex;
    font-size: 0;
  }

  &.input-error {
    .alert {
      &::before {
        content: "";
        position: absolute;
        top: 0; right: 0;
        bottom: 0; left: 0;
        border: 1px solid red;
        border-radius: 4px;
        z-index: 1;
        animation: blink 0.5s linear 0s infinite alternate;
      }

      @keyframes blink {
        from {
          border-color: red;
        }
        to {
          border-color: transparent;
        }
      }
    }
  }
}

/* label */
.custom-label {
  display: inline-flex;
  margin: 0 0 8px 0;
  cursor: pointer;
  color: $label_color;
}

/* input */
input,
input.custom-input,
input.el-input__inner {
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  padding: 0 16px;
  border: 1px solid transparent;
  border-radius: 4px;
  box-shadow: 0 4px 12px 0 rgba(95, 136, 204, 0.16);
  line-height: 1.5;
  font-family: $input_font-family;
  font-size: $input_font-size;
  color: $input_color;
  transition: $base-transition;
  &:focus {
    outline: none;
    box-shadow: 0 4px 12px 0 rgba(95, 136, 204, 0.26);
  }
}

/* disable arrows in input type number */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"] {
  -moz-appearance:textfield;
}
input[type="number"]::-ms-clear,
input[type="number"]::-ms-reveal {
  display: none;
  width: 0;
  height: 0;
}

/* placeholder */
input::-webkit-input-placeholder {
  font-family: $main-font;
  opacity: 1;
  color: $input_placeholder-color;
  transition: $base-transition;
}
input::-moz-placeholder {
  font-family: $main-font;
  opacity: 1;
  color: $input_placeholder-color;
  transition: $base-transition;
}
input:-moz-placeholder {
  font-family: $main-font;
  opacity: 1;
  color: $input_placeholder-color;
  transition: $base-transition;
}
input:-ms-input-placeholder {
  font-family: $main-font;
  opacity: 1;
  color: $input_placeholder-color;
  transition: $base-transition;
}

input:focus::-webkit-input-placeholder {
  opacity: 0;
  transition: $base-transition;
}
input:focus::-moz-placeholder {
  opacity: 0;
  transition: $base-transition;
}
input:focus:-moz-placeholder {
  opacity: 0;
  transition: $base-transition;
}
input:focus:-ms-input-placeholder {
  opacity: 0;
  transition: $base-transition;
}

/* buttons */
.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  border: none;
  font-family: $main-font;
  font-weight: bold;
  cursor: pointer;
  transition: $base-transition;

  &.default-size {
    height: 48px;
    border-radius: 4px;
    &.uppercase {
      font-size: 16px;
    }
  }

  &.uppercase {
    text-transform: uppercase;
  }

  &.full-width {
    max-width: 100%;
    width: 100%;
  }

  &.blue {
    background: #1a85ff;
    color: #ffffff;
    &:hover {
      background: #449cff;
    }
  }
}
</style>
